/* LQK Word Search — Discovering Sayyidah Fatimah (RA).
 * Drag across the letters to find every hidden word.
 * Depends on lqk-games-kit.js (window.LQKG).
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-lqkg-wordsearch]');
  if (!root || !window.LQKG) return;
  var K = window.LQKG;

  var WORDS = JSON.parse(root.getAttribute('data-words'));
  var LEVELS = [
    { size: 8, words: 6, dirs: [[1, 0], [0, 1], [1, 1]] },
    { size: 12, words: WORDS.length, dirs: [[1, 0], [0, 1], [1, 1], [1, -1], [-1, 0], [0, -1]] },
  ];
  var ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  var gridEl = root.querySelector('[data-grid]');
  var listEl = root.querySelector('[data-words-list]');
  var foundEl = root.querySelector('[data-found]');
  var timerEl = root.querySelector('[data-time]');
  var levelBtns = root.querySelectorAll('.lqkg__level');
  K.soundButton(root.querySelector('[data-sound]'));
  var win = K.modal(root);
  var clock = K.timer(timerEl);

  var level = 0, grid, size, placed, found, started;

  function build() {
    var cfg = LEVELS[level];
    size = cfg.size;
    var words = K.shuffle(WORDS).slice(0, cfg.words).map(function (w) { return w.toUpperCase(); });
    // longest first packs more reliably
    words.sort(function (a, b) { return b.length - a.length; });
    for (var attempt = 0; attempt < 60; attempt++) {
      grid = [];
      for (var r = 0; r < size; r++) grid.push(new Array(size).fill(null));
      placed = [];
      var ok = words.every(place.bind(null, cfg.dirs));
      if (ok) break;
    }
    for (var y = 0; y < size; y++)
      for (var x = 0; x < size; x++)
        if (!grid[y][x]) grid[y][x] = ALPHA[Math.floor(Math.random() * 26)];
    render();
  }

  function place(dirs, word) {
    for (var tries = 0; tries < 220; tries++) {
      var d = dirs[Math.floor(Math.random() * dirs.length)];
      var maxX = d[0] > 0 ? size - word.length : d[0] < 0 ? word.length - 1 : size - 1;
      var minX = d[0] < 0 ? word.length - 1 : 0;
      var maxY = d[1] > 0 ? size - word.length : d[1] < 0 ? word.length - 1 : size - 1;
      var minY = d[1] < 0 ? word.length - 1 : 0;
      if (maxX < minX || maxY < minY) continue;
      var x = minX + Math.floor(Math.random() * (maxX - minX + 1));
      var y = minY + Math.floor(Math.random() * (maxY - minY + 1));
      var fits = true;
      for (var i = 0; i < word.length; i++) {
        var c = grid[y + d[1] * i][x + d[0] * i];
        if (c && c !== word[i]) { fits = false; break; }
      }
      if (!fits) continue;
      for (var j = 0; j < word.length; j++) grid[y + d[1] * j][x + d[0] * j] = word[j];
      placed.push({ word: word, x: x, y: y, d: d, found: false });
      return true;
    }
    return false;
  }

  function render() {
    found = 0; started = false;
    clock.reset();
    foundEl.textContent = '0/' + placed.length;
    gridEl.style.setProperty('--ws-size', size);
    gridEl.innerHTML = '';
    for (var y = 0; y < size; y++) {
      for (var x = 0; x < size; x++) {
        var cell = document.createElement('span');
        cell.className = 'lqkg-ws__cell';
        cell.textContent = grid[y][x];
        cell.dataset.x = x; cell.dataset.y = y;
        gridEl.appendChild(cell);
      }
    }
    listEl.innerHTML = '';
    placed.forEach(function (p) {
      var li = document.createElement('span');
      li.className = 'lqkg-ws__word';
      li.textContent = p.word;
      li.setAttribute('data-word', p.word);
      listEl.appendChild(li);
    });
  }

  /* drag selection */
  var anchor = null, current = null;
  function cellAt(clientX, clientY) {
    var el = document.elementFromPoint(clientX, clientY);
    return el && el.classList && el.classList.contains('lqkg-ws__cell') ? el : null;
  }
  function lineCells(a, b) {
    var x0 = +a.dataset.x, y0 = +a.dataset.y, x1 = +b.dataset.x, y1 = +b.dataset.y;
    var dx = Math.sign(x1 - x0), dy = Math.sign(y1 - y0);
    var len = Math.max(Math.abs(x1 - x0), Math.abs(y1 - y0));
    // only straight or 45° lines count
    if (!(dx === 0 || dy === 0 || Math.abs(x1 - x0) === Math.abs(y1 - y0))) return null;
    var cells = [];
    for (var i = 0; i <= len; i++) {
      var el = gridEl.children[(y0 + dy * i) * size + (x0 + dx * i)];
      if (!el) return null;
      cells.push(el);
    }
    return cells;
  }
  function paint(cells) {
    gridEl.querySelectorAll('.is-active').forEach(function (c) { c.classList.remove('is-active'); });
    (cells || []).forEach(function (c) { c.classList.add('is-active'); });
  }
  gridEl.addEventListener('pointerdown', function (e) {
    var c = cellAt(e.clientX, e.clientY);
    if (!c) return;
    e.preventDefault();
    if (!started) { started = true; clock.start(); }
    anchor = c; current = c;
    paint([c]);
    gridEl.setPointerCapture && gridEl.setPointerCapture(e.pointerId);
  });
  gridEl.addEventListener('pointermove', function (e) {
    if (!anchor) return;
    var c = cellAt(e.clientX, e.clientY);
    if (c && c !== current) { current = c; paint(lineCells(anchor, current) || [anchor]); }
  });
  function finish(e) {
    if (!anchor) return;
    var cells = lineCells(anchor, current);
    anchor = null;
    paint([]);
    if (!cells || cells.length < 2) return;
    var text = cells.map(function (c) { return c.textContent; }).join('');
    var rev = text.split('').reverse().join('');
    var hit = placed.find(function (p) { return !p.found && (p.word === text || p.word === rev); });
    if (!hit) { K.sound.buzz(); return; }
    hit.found = true; found++;
    foundEl.textContent = found + '/' + placed.length;
    cells.forEach(function (c) { c.classList.add('is-found'); });
    listEl.querySelector('[data-word="' + hit.word + '"]').classList.add('is-found');
    K.sound.ding(); K.vibrate(30);
    if (found === placed.length) {
      clock.stop();
      K.confetti(); K.sound.win();
      win.show({
        title: 'Masha Allah!', stars: 3,
        text: 'You found all ' + placed.length + ' words in ' + timerEl.textContent + '!',
        againLabel: 'New puzzle', onAgain: build,
      });
    }
  }
  gridEl.addEventListener('pointerup', finish);
  gridEl.addEventListener('pointercancel', finish);

  levelBtns.forEach(function (b, i) {
    b.addEventListener('click', function () {
      level = i;
      levelBtns.forEach(function (x, j) { x.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      K.sound.tap();
      build();
    });
  });

  build();
})();
